const layoutTypes = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
};

const layoutWidthTypes = {
  FLUID: "fluid",
  BOXED: "boxed",
  SCROLLABLE: "scrollable",
};

const topBarThemeTypes = {
  LIGHT: "light",
  DARK: "dark",
  COLORED: "colored",
};

const leftBarThemeImageTypes = {
  NONE: "none",
  IMG1: "img1",
  IMG2: "img2",
  IMG3: "img3",
  IMG4: "img4",
};

const leftSidebarTypes = {
  DEFAULT: "default",
  COMPACT: "compact",
  ICON: "icon",
};

const leftSideBarThemeTypes = {
  LIGHT: "light",
  COLORED: "colored",
  DARK: "dark",
  WINTER: "winter",
  LADYLIP: "ladylip",
  PLUMPLATE: "plumplate",
  STRONGBLISS: "strongbliss",
  GREATWHALE: "greatwhale",
};

const MENU_CODE = {
  REPORT: {
    code: "REPORT",
    childMenu: {},
  },
  NOTICE_FROM_TCT: {
    code: "NOTICE_FROM_TCT",
    childMenu: {},
  },
  GENERAL_INFORMATIONS: {
    code: "GENERAL_INFORMATIONS",
    childMenu: {},
  },
  DATA_FORMAT: {
    code: "DATA_FORMAT",
  },
  TEMPLATE_MANAGEMENT: {
    code: "TEMPLATE_MANAGEMENT",
    childMenu: {},
  },
  ISSUE_VAT_INVOICE: {
    code: "ISSUE_VAT_INVOICE",
    childMenu: {},
  },
  ISSUE_SALES_INVOICE: {
    code: "ISSUE_SALES_INVOICE",
    childMenu: {},
  },
  ISSUE_ANOTHER_INVOICE: {
    code: "ISSUE_ANOTHER_INVOICE",
    childMenu: {},
  },
};

const returnImgByMenuCode = code => {
  switch (code) {
    case MENU_CODE.REPORT.code:
      return "bx bxs-report";
    case MENU_CODE.NOTICE_FROM_TCT.code:
      return "bx bx-bell";
    case MENU_CODE.DATA_FORMAT.code:
      return "bx bx-data";
    case MENU_CODE.DATA_FORMAT.code:
      return "bx bx-data";
    case MENU_CODE.ISSUE_VAT_INVOICE.code:
      return "bx bx-receipt";
    case MENU_CODE.ISSUE_SALES_INVOICE.code:
      return "bx bx-receipt";
    case MENU_CODE.ISSUE_ANOTHER_INVOICE.code:
      return "bx bx-receipt";
    default:
      return "bx bx-message-rounded-x";
  }
};

export {
  layoutTypes,
  layoutWidthTypes,
  topBarThemeTypes,
  leftBarThemeImageTypes,
  leftSidebarTypes,
  leftSideBarThemeTypes,
  MENU_CODE,
  returnImgByMenuCode,
};
